import React from 'react'
import { Box, Divider, Grid, Skeleton } from '@mui/material'

/**
 * Skeleton model Chips loader for add new vehicle flow.
 * @returns
 */

export const ModelChipsLoader: React.FC = () => {
  const items = new Array(35).fill('')
  const randomWidth = (min: number, max: number) => {
    return Math.floor(Math.random() * (max - min + 1) + min)
  }
  return (
    <>
      <Skeleton variant='rounded' animation='wave' height={30} width={215} sx={{ mb: 2 }} />
      <Box sx={{ display: 'flex', flexWrap: 'wrap' }}>
        {items.map((_item, index) => {
          return (
            <Skeleton
              key={index}
              variant='rectangular'
              animation='wave'
              height={20}
              width={randomWidth(35, 170)}
              sx={{ borderRadius: 50, mr: 2, mb: 2 }}
            />
          )
        })}
      </Box>
    </>
  )
}

/**
 * Skeleton model list loader for add new vehicle flow.
 * @returns
 */

export const ModelListLoader: React.FC = () => {
  const tableColumns = new Array(4).fill('')
  return (
    <>
      <Skeleton variant='rounded' animation='wave' height={30} width={215} sx={{ mb: 2 }} />
      <Grid container>
        {tableColumns.map((_column, index) => {
          return (
            <Grid key={index} item xs={index === 0 ? 6 : 2}>
              <Skeleton variant='text' animation='wave' width={80} height={30} sx={{ mb: 2, ml: index === 0 ? 1 : 'auto', mr: 1 }} />
              <Skeleton variant='text' animation='wave' sx={{ mx: 1 }} />
              <Divider sx={{ my: 1 }} />
              <Skeleton variant='text' animation='wave' sx={{ mx: 1 }} />
              <Divider sx={{ my: 1 }} />
              <Skeleton variant='text' animation='wave' sx={{ mx: 1 }} />
              <Divider sx={{ my: 1 }} />
              <Skeleton variant='text' animation='wave' sx={{ mx: 1 }} />
              <Divider sx={{ my: 1 }} />
            </Grid>
          )
        })}
      </Grid>
    </>
  )
}
